var React = require('react');

function ProductsIcon13Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_19","data-name":"Obszar roboczy 19","transform":"translate(-8.99 -7.25)"},[React.createElement("path",{"id":"Path_294","data-name":"Path 294","d":"M25.11,33.63,20.34,19.37h3.19L28.3,33.63Z","key":0}),React.createElement("path",{"id":"Path_295","data-name":"Path 295","d":"M12.09,33.63l4.78-14.26h3.19L15.29,33.63Z","key":1}),React.createElement("rect",{"id":"Rectangle_1007","data-name":"Rectangle 1007","width":"22.32","height":"2.8","transform":"translate(8.99 13.37)","key":2}),React.createElement("rect",{"id":"Rectangle_1008","data-name":"Rectangle 1008","width":"3","height":"2.8","transform":"translate(18.65 7.25)","key":3})]));
}

ProductsIcon13Inline.defaultProps = {"width":"22.32","height":"26.38","viewBox":"0 0 22.32 26.38"};

module.exports = ProductsIcon13Inline;

ProductsIcon13Inline.default = ProductsIcon13Inline;
